import $ from 'jquery';

export const check = ($holder, $input) => {
    if ($input.attr('type') === 'checkbox') {
        $holder.toggleClass('fn-active');
        $input.prop('checked', $holder.hasClass('fn-active'));
    }
};

export const elements = {
    call: '.js-Checkbox-Call',
    holder: '.js-Checkbox-Holder',
    dummy: '.js-Checkbox-Dummy',
};

export const onClick = function () {
    const $this = $(this);
    const holder = $this.parents(elements.holder);

    // We only want to toggle the class and not to change the state of the input
    // when the event is being fired on it.
    if ($this.is('input')) {
        holder.toggleClass('fn-active');
    } else {
        const input = holder.find('input').first();

        if (holder.hasClass('js-Comments-Moderation')) {
            $('.js-Comment-Action-Box').toggleClass('fn-withoutmode');
        }

        check(holder, input);
    }
};

export default {
    init(params) {
        params.$document
            .off('click', elements.call)
            .on('click', elements.call, onClick);
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/checkbox.js